// extracted by mini-css-extract-plugin
export default {"voucherText":"VoucherText_voucherText__9meVu"};